import * as types from './types';

function trackIDRequest(trackID) {
  return {
    type: types.TRACKID_REQUEST,
    payload: {
      trackID,
    },
  };
}

export function getTrackID(id) {
  return async (dispatch) => {
    dispatch(trackIDRequest(id));
  };
}



// WEBPACK FOOTER //
// ./src/redux/track/actions.js